import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { CatalogProvider } from './context/CatalogContext';
import { PathsProvider } from './context/PathsContext';
import AppLayout from './components/layout/AppLayout';
import HomePage from './features/home/HomePage';
import ModulesPage from './features/modules/ModulesPage';
import ModuleDetailPage from './features/modules/ModuleDetailPage';
import LearningPathsPage from './features/learningPaths/LearningPathsPage';
import LearningPathDetailPage from './features/learningPaths/LearningPathDetailPage';
import CreatePathPage from './features/createPath/CreatePathPage';
import ProfilePage from './features/profile/ProfilePage';
import SearchPage from './features/search/SearchPage';
import NotFoundPage from './components/common/NotFoundPage';

const theme = createTheme({
  palette: {
    primary:    { main: '#0078d4' },
    secondary:  { main: '#7c3aed' },
    background: { default: '#f6f8fa', paper: '#ffffff' },
    text:       { primary: '#111827', secondary: '#6b7280' },
  },
  typography: {
    fontFamily: [
      '-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto',
      '"Helvetica Neue"', 'Arial', 'sans-serif',
    ].join(','),
    h1: { fontWeight: 800, letterSpacing: '-2px' },
    h2: { fontWeight: 800, letterSpacing: '-1.5px' },
    h3: { fontWeight: 800, letterSpacing: '-1px' },
    h4: { fontWeight: 700, letterSpacing: '-0.5px' },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 10,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 8 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
      },
    },
  },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <CatalogProvider>
        <PathsProvider>
          <Router>
            <AppLayout>
              <Routes>
                <Route path="/"                              element={<HomePage />} />
                <Route path="/modules"                       element={<ModulesPage />} />
                <Route path="/modules/:moduleId"             element={<ModuleDetailPage />} />
                <Route path="/learning-paths"                element={<LearningPathsPage />} />
                <Route path="/learning-paths/:pathId"        element={<LearningPathDetailPage />} />
                <Route path="/create-path"                   element={<CreatePathPage />} />
                <Route path="/search"                        element={<SearchPage />} />
                <Route path="/profile"                       element={<ProfilePage />} />
                <Route path="*"                              element={<NotFoundPage />} />
              </Routes>
            </AppLayout>
          </Router>
        </PathsProvider>
      </CatalogProvider>
    </ThemeProvider>
  );
}
